<template>
  <article class="invoice-create-card invoice-create-card--accent-contacts">
    <header class="invoice-create-card__head">
      <h3>
        <i class="fa fa-file-text-o invoice-create-section-icon invoice-create-section-icon--contacts" aria-hidden="true"></i>
        {{ text.create.ui.infoCard.title }}
      </h3>
    </header>

    <div class="invoice-create-info-grid">
      <div class="invoice-create-field app-modal-field invoice-create-field--date">
        <span>{{ text.create.ui.infoCard.fields.date }}</span>
        <VueDatePicker
          :model-value="noteInfo.date"
          class="app-modal-datepicker"
          menu-class-name="app-modal-datepicker-menu"
          :placeholder="text.create.ui.infoCard.placeholders.date"
          :enable-time-picker="false"
          auto-apply
          locale="es-MX"
          format="dd/MM/yyyy"
          model-type="yyyy-MM-dd"
          hide-input-icon
          :show-now-button="true"
          :now-button-label="text.create.ui.infoCard.values.todayButton"
          @update:model-value="$emit('note-info-change', { key: 'date', value: $event || '' })"
        />
      </div>

      <div class="invoice-create-field app-modal-field invoice-create-field--folio">
        <span>{{ text.create.ui.infoCard.fields.folio }}</span>
        <div class="invoice-create-field-static">{{ resolvedFolio }}</div>
      </div>

      <div class="invoice-create-field app-modal-field invoice-create-field--payment-form">
        <span>{{ text.create.ui.infoCard.fields.paymentForm }}</span>
        <multiselect
          v-model="paymentFormModel"
          :options="effectivePaymentFormOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="false"
          :allow-empty="false"
          class="app-modal-select"
          :placeholder="text.create.ui.infoCard.placeholders.paymentForm"
        />
      </div>
    </div>
  </article>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('simpleNotes');

export default {
  name: 'SimpleNoteCreateInfoCard',
  components: {
    VueDatePicker,
  },
  props: {
    noteInfo: {
      type: Object,
      required: true,
    },
    paymentFormOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['note-info-change'],
  data() {
    return {
      text,
    };
  },
  computed: {
    effectivePaymentFormOptions() {
      if (Array.isArray(this.paymentFormOptions) && this.paymentFormOptions.length > 0) {
        return this.paymentFormOptions;
      }

      return [
        {
          value: '01',
          label: String(this.text?.create?.ui?.infoCard?.values?.fallbackPaymentFormOption || '').trim() || '01',
        },
      ];
    },
    paymentFormModel: {
      get() {
        return this.effectivePaymentFormOptions.find((option) => {
          return String(option?.value || '') === String(this.noteInfo?.paymentForm || '');
        }) || this.effectivePaymentFormOptions[0] || null;
      },
      set(option) {
        this.$emit('note-info-change', {
          key: 'paymentForm',
          value: String(option?.value || '').trim(),
        });
      },
    },
    resolvedFolio() {
      const prefix = String(this.text?.create?.ui?.infoCard?.values?.defaultSeries || 'NS').trim() || 'NS';
      const folio = String(this.noteInfo?.folio || '').trim();
      return `${prefix}${folio}`;
    },
  },
};
</script>

<style scoped>
.invoice-create-info-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 12px;
}

.invoice-create-field--date {
  grid-column: span 4;
}

.invoice-create-field--folio {
  grid-column: span 2;
}

.invoice-create-field--payment-form {
  grid-column: span 6;
}

@media (max-width: 760px) {
  .invoice-create-info-grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .invoice-create-field--date,
  .invoice-create-field--folio,
  .invoice-create-field--payment-form {
    grid-column: auto;
  }
}
</style>
